import {endsWith} from 'lodash';
import UrlParser from 'url-parse';

/**
 * @name matchDomain
 */
export const matchDomain = (
  url: string,
  domain: string,
  allowSubdomains = true
): boolean => {
  const parsedUrl = new UrlParser(url, '/', true);
  const hostname = parsedUrl.hostname;

  if (
    hostname === domain ||
    (allowSubdomains && endsWith(hostname, `.${domain}`))
  ) {
    return true;
  }

  return false;
};
